/* eslint-disable no-unused-vars */
import { FormField, FormFieldType } from './formField'
import { QuestionFormFieldValidation } from './questionFormFieldValidation'

/**
 * Creates an instance of QuestionFormField.
 * @typedef {Object} QuestionFormFieldType
 * @property {boolean} readOnly
 * @property {string} hint - To be displayed underneath input
 * @property {any} defaultValue
 * @property {QuestionFormFieldValidation} validate - Contains validation rules for question
 *
 * @typedef {FormFieldType & QuestionFormFieldType} QuestionFormFieldExtendType
 */

/**
 * Represents a question form field.
 * @class
 */
export class QuestionFormField extends FormField {
  /**
   * Create a new QuestionFormField.
   * @param {QuestionFormFieldExtendType} params
   */
  constructor(params) {
    super(params)
    this.readOnly = params.readOnly
    this.hint = params.hint
    this.defaultValue = params.defaultValue
    this.validate = params.validate
      ? new QuestionFormFieldValidation(params.validate)
      : null
  }
}
